import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach admin token automatically for /admin/* calls
api.interceptors.request.use((config) => {
  if (config.url && config.url.startsWith("/admin")) {
    const token = localStorage.getItem("coc_admin_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// Public
export const subscribeNewsletter = (payload) =>
  api.post("/newsletter", payload).then((r) => r.data);

export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const resourcePdfUrl = (slug) => `${API}/resources/${slug}.pdf`;

// Admin
export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

export const adminVerify = () => api.get("/admin/verify").then((r) => r.data);

export const adminStats = () => api.get("/admin/stats").then((r) => r.data);

export const adminListNewsletter = () =>
  api.get("/admin/newsletter").then((r) => r.data);

export const adminListContact = () =>
  api.get("/admin/contact").then((r) => r.data);

// Token helpers
export const TOKEN_KEY = "coc_admin_token";
export const setAdminToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);
export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
